import React from "react";
import MainLayout from "./MainLayout";
import AccountSettings from "../common/auth/AccountSettings";

const AccountSettingsPage = (props) => <MainLayout component={AccountSettings} />;

export default AccountSettingsPage;
